(ns url.how-it-works
  "The humbleai.com pages explaining each of Humble's apps. Shared so these
   destinations live in one place rather than being pasted into every card and
   menu that links to them.")

(def ^:private base-url
  "https://humbleai.com/how-it-works/")

(def tasks-url
  (str base-url "tasks/"))

(def notes-url
  (str base-url "notes/"))

(def calendar-url
  (str base-url "calendar/"))

(def timeline-url
  (str base-url "timeline/"))

(def contacts-url
  (str base-url "contacts/"))
